export { CompliancePoliciesPage as default } from "@nvb/ui";
